// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_23-1";
export var rateTableServiceLevelDropdown = "_23-3";
export var rateTableTypeDropdown = "_23-0";
export var rateTableValueModeDropdown = "_23-2";